import React from "react";
import "./FooterStyle.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-modern">
      <div className="footer-main">
        <div className="container">
          <div className="row g-4">
            {/* Company Info Section */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-section">
                <h5 className="footer-heading">TinyPDF Converter</h5>
                <p className="footer-description">
                  Transform your documents with our powerful PDF processing API.
                  Fast, reliable, and secure document conversion solutions.
                </p>
                <div className="footer-social">
                  <a
                    href="#"
                    className="footer-social-link"
                    aria-label="Facebook"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a
                    href="#"
                    className="footer-social-link"
                    aria-label="Twitter"
                  >
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a
                    href="#"
                    className="footer-social-link"
                    aria-label="LinkedIn"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                  <a
                    href="#"
                    className="footer-social-link"
                    aria-label="GitHub"
                  >
                    <i className="fa fa-github"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-section">
                <h6 className="footer-heading">Quick Links</h6>
                <ul className="footer-links-list">
                  <li>
                    <a href="/" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>Home</span>
                    </a>
                  </li>
                  <li>
                    <a href="#features" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>Features</span>
                    </a>
                  </li>
                  <li>
                    <a href="#pricing" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>Pricing</span>
                    </a>
                  </li>
                  <li>
                    <a href="#about" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>About Us</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Services Section */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-section">
                <h6 className="footer-heading">Services</h6>
                <ul className="footer-links-list">
                  <li>
                    <a href="#convert" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>PDF Conversion</span>
                    </a>
                  </li>
                  <li>
                    <a href="#merge" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>Merge PDFs</span>
                    </a>
                  </li>
                  <li>
                    <a href="#compress" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>Compress PDFs</span>
                    </a>
                  </li>
                  <li>
                    <a href="#api" className="footer-link-item">
                      <i className="fa fa-chevron-right"></i>
                      <span>API Documentation</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Section */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-section">
                <h6 className="footer-heading">Contact Us</h6>
                <ul className="footer-contact-list">
                  <li className="footer-contact-item">
                    <i className="fa fa-map-marker"></i>
                    <span>123 Business Street, Suite 100</span>
                  </li>
                  <li className="footer-contact-item">
                    <i className="fa fa-phone"></i>
                    <span>+1 (555) 123-4567</span>
                  </li>
                  <li className="footer-contact-item">
                    <i className="fa fa-envelope"></i>
                    <span>support@pdfapi.com</span>
                  </li>
                  <li className="footer-contact-item">
                    <i className="fa fa-clock-o"></i>
                    <span>Mon - Fri: 9:00 AM - 6:00 PM</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="footer-copyright">
                &copy; {currentYear} PDF API. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="footer-bottom-links">
                <a href="#privacy" className="footer-bottom-link">
                  Privacy Policy
                </a>
                <span className="footer-separator">|</span>
                <a href="#terms" className="footer-bottom-link">
                  Terms of Service
                </a>
                <span className="footer-separator">|</span>
                <a href="#cookies" className="footer-bottom-link">
                  Cookie Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
